import React from 'react';
import styles from './AboutSection.module.scss';
import conhecaAHistoria from '../../images/conheca-a-historia.svg';
import betula from '../../images/betula.svg';
import prrofessorres from '../../images/prrofessorres.svg';

function AboutSection() {
  return (
    <div className={styles.about}>
      <div className={styles.intro}>
        <p>
          Queremos <strong>povoar o imaginário</strong> das pessoas com
          histórias que ajudem elas a{' '}
          <strong>questionarem o papel da tecnologia em suas vidas</strong>.
        </p>
        <p>
          Criamos uma <strong>série audiovisual de 8 episódios</strong> com
          humor, personagens, animações e músicas.
        </p>
      </div>
      <div className={styles.title}>
        <img src={conhecaAHistoria} alt="Conheça a História" />
      </div>
      <div className={styles.container}>
        <div className={styles.betula}>
          <img src={betula} alt="Betula" />
          <p>
            O vilão da série é Conde Bétula, o Vampiro da Atenção, que usa da
            sua mais nova invenção, o Celular FOMOrcego, para roubar a atenção
            de toda a humanidade e trocar ela por dinheiro para se tornar
            imparável.
          </p>
        </div>
        <div className={styles.prof}>
          <img src={prrofessorres} alt="Professores" />
          <p>
            Os heróis da série são os Prrofessorres: Neto, Frigideira e Canário
            que estão desenvolvendo tecnologias com criatividade e imaginação
            para investigar o roubo da atenção e parar o terrível Conde Bétula.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutSection;
